import React          from 'react';
import classnames     from 'classnames';
import Tooltip        from './Tooltip';
import Label          from './Label';
import RadioComponent from './RadioComponent';

const RadioDualComponent = (props) => {
  const { name, parameters } = props;
  const value = parameters.get ? parameters.get(name) : parameters[name];
  return (
    <div className={classnames('form-group', props.className)}>
      <Label label={props.label} required={props.required} className={'label-component d-block'} >
        <Tooltip id={`tooltip-${props.name}`} title={props.tooltip} />
      </Label>
      {' '}
      <RadioComponent
        inputId={`${props.name}-${props.valueA}`}
        name={name}
        label={props.labelA}
        value={props.valueA}
        checked={value === props.valueA}
        onChange={props.onChange}
        inline />
      {' '}
      <RadioComponent
        inputId={`${props.name}-${props.valueB}`}
        name={name}
        label={props.labelB}
        value={props.valueB}
        checked={value === props.valueB}
        onChange={props.onChange}
        inline />
      <div>{props.children}</div>
    </div>
  );
};

RadioDualComponent.defaultProps = {
  labelA: 'Yes',
  labelB: 'No',
  valueA: '1',
  valueB: '0',
};

export default RadioDualComponent;
